import { render } from "./DtGiftVoucherStatus.vue?vue&type=template&id=04e441fc"
import script from "./DtGiftVoucherStatus.vue?vue&type=script&lang=js"
export * from "./DtGiftVoucherStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__